/**
 * Created Date: 2020-10-20
 * Author: Grays
 * -----
 * Last Modified: 2020-10-26 12:57:03
 * Modified By: Grays
 * 
 */


const simple_time=(time)=>{
    let d  = new Date(Date.parse(time.replace(/-/g,   "/")));
    let now = new Date()
    if (d.getFullYear()===now.getFullYear()&&d.getMonth()==now.getMonth()&&d.getDay()==now.getDay()){
        return date_format('HH:MM',d)
    }else if(d.getFullYear()===now.getFullYear()){
        return date_format('mm-dd HH:MM',d)
    }else 
        return  date_format('YYYY-mm-dd HH:MM',d)
}
const  date_format=(fmt, date)=> {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}
const isElementNotInViewport = function(el) {
    let rect = el.getBoundingClientRect();
    return (
      rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
      rect.bottom <= 0
    );
  };
  
export default{
    simple_time:simple_time,
    date_format:date_format,
    isElementNotInViewport:isElementNotInViewport
}